import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionText?: string;
  actionLink?: string;
}

export default function EmptyState({
  icon = "ri-search-eye-line",
  title,
  description,
  actionText,
  actionLink,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 rounded-xl bg-background-100 border border-dashed border-background-300">
      <span className="w-16 h-16 rounded-full bg-background-200 text-foreground-400 flex items-center justify-center mb-4">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="text-base font-semibold text-foreground-900">{title}</h3>
      {description && <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>}
      {actionText && actionLink && (
        <Link
          to={actionLink}
          className="mt-5 inline-flex items-center gap-1.5 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-left-line text-base" />
          </span>
          {actionText}
        </Link>
      )}
    </div>
  );
}